import { render } from "./RequestBourseDossardInscriptionView.vue?vue&type=template&id=7820c654"
import script from "./RequestBourseDossardInscriptionView.vue?vue&type=script&lang=js"
export * from "./RequestBourseDossardInscriptionView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Downloads\\nm_sportips-inscriptions-main\\nm_sportips-inscriptions-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__